import ItemList from '../../common/utils/ItemList';
import AbstractGlobalSearch from '../../common/components/AbstractGlobalSearch';
import GeneralSearchSource from './GeneralSearchSource';
import app from '../app';
export default class GlobalSearch extends AbstractGlobalSearch {
  static initAttrs(attrs) {
    attrs.label = app.translator.trans('core.admin.header.search_placeholder', {}, true);
    attrs.a11yRoleLabel = app.translator.trans('core.admin.header.search_role_label', {}, true);
  }
  sourceItems() {
    const items = new ItemList();
    items.add('general', new GeneralSearchSource());
    return items;
  }
}
flarum.reg.add('core', 'admin/components/GlobalSearch', GlobalSearch);